import { render } from "./busView.vue?vue&type=template&id=38c06c70&scoped=true"
import script from "./busView.vue?vue&type=script&lang=js"
export * from "./busView.vue?vue&type=script&lang=js"

import "./busView.vue?vue&type=style&index=0&id=38c06c70&scoped=true&lang=css"
import "./busView.vue?vue&type=style&index=1&id=38c06c70&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c06c70"]])

export default __exports__